<template>
  <div>
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="所属分类">
        <Cascader
          :data="catagoris"
          v-model="classify_ids"
          trigger="hover"
          style="width:200px;"
          change-on-select
        ></Cascader>
      </FormItem>
      <FormItem label="练习状态">
        <Select v-model="searchCondition.status" style="width:200px;" clearable>
          <Option
            v-for="(item, index) in exerciseStatus"
            :key="index"
            :value="item.key"
          >{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="练习名称">
        <Input
          v-model="searchCondition.name"
          placeholder="请输入练习名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </FormItem>
    </Form>
    <Button type="primary"  :to="{name: 'QuestionExerciseAdd'}" style="margin-right:50px;">
      新增练习
      </Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/exam/exercise"
        :search="searchCondition"
        @onSelectionChange="onSelectionChange"
        :rowsFormatter="rowsFormatter"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button v-if="row.status==3||row.status==2" type="text" size="small" @click="onShelf(1,row)">上架</Button>
            <Button v-else type="text" size="small" @click="onShelf(2,row)">下架</Button>
            <span>-</span>
            <Button
              type="text"
              size="small"
              :to="{name:'QuestionExerciseChapter', query:{exercise_id: row.id}}"
            >章节列表</Button>
            <span>-</span>
            <Button type="text"  :to="{name: 'QuestionExerciseAdd' ,query: {id: row.id}}">编辑</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onForbidden(row.id)">删除</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button class="btn-margin-right" size="small" @click="onForbidden">删除</Button>
          <Button class="btn-margin-right" size="small" @click="onShelf(1)">上架</Button>
          <Button class="btn-margin-right" size="small" @click="onShelf(2)">下架</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
import { ExerciseStatus } from "@/utils/enums";
export default {
  name: "QuestionExercise",
  data() {
    return {
      classify_ids: [],
      catagoris: [],
      exerciseStatus: ExerciseStatus.getOptions(),
      searchCondition: {
        status: "",
        name: "",
        classify_id: [],
        init: function() {
          this.status = "";
          this.name = "";
          this.classify_id = [];
        }
      },
      onlyShowMe: false,
      tableColumns: [
        { title: "练习名称", key: "name", align: "center", minWidth: 180 },
        {
          title: "所属分类",
          key: "classify_name",
          align: "center",
          minWidth: 120
        },
        { title: "状态", key: "exercise_state", align: "center", minWidth: 100 },
        {
          title: "更新时间",
          key: "updated_at",
          align: "center",
          minWidth: 160
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 100,
          fixed: "right"
        }
      ],
      selectItems: []
    };
  },
  async created() {
    let catagoris = await this.$http.get("/api/course/classify");
    this.catagoris = catagoris;
  },
  methods: {
    rowsFormatter(rows) {
      console.log(rows)
      let nowTime = Date.parse(new Date());
      rows.forEach(item => {
        console.log(item)
        item.classify_name = item.classify.title;
        item.updated_at = this.$pub.timestampToTime(item.updated_at);
        if (item.status == 1) {
          item.exercise_state = "已上架";
        } else if (item.status == 2) {
          item.exercise_state = "已下架";
        } else {
          item.exercise_state = "待上架";
        }
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.init();
        this.classify_ids = [];
      }
      this.searchCondition.classify_id = this.classify_ids[1] || this.classify_ids[0];
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(items) {
      this.selectItems = items;
    },
    onShelf(status, item) {
      let content = '上架';
      if(status == 2){
        content = '下架';
      }
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要" + content + "该章节练习吗？</p>",
        onOk: () => {
          this.nextShelfAction(status,item);
        }
      });
    },
    /**
     * @param {String} id    试卷id
     */
    onForbidden(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要删除该章节练习吗？</p>",
        onOk: () => {
          this.nextAction(id);
        }
      });
    },
    nextAction(id) {
      let ids = "";
      if (id) {
        ids = id;
      } else {
        this.selectItems.forEach(item => {
          ids += item.id + ",";
        });
        ids = ids.substr(0, ids.length - 1);
      }
      this.$http.delete(`/api/exam/exercise/${ids}`).then(() => {
        this.$Message.deleteSuccess();
        this.search(1);
      });
    },
    nextShelfAction(status,item) {
      let ids = "";
      if (item) {
        if( item.exams.length <= 0 && status ==1) {
          this.$Message.error("请先设置章节列表");
          return;
        }
        ids = item.id;
      } else {
        let hasNoChapter = 0;
        this.selectItems.forEach(item => {
          if( item.exams.length <= 0 ) {
            hasNoChapter = 1;
          }
          ids += item.id + ",";
        });
        if(hasNoChapter > 0 ) {
          this.$Message.error("存在练习未设置章节列表，请先设置！");
          return;
        }
        ids = ids.substr(0, ids.length - 1);
      }
      this.$http.put(`/api/exam/exercise/status/${ids}`, {status}).then(() => {
          status == 1 && this.$Message.success("上架成功");
          status == 2 && this.$Message.success("下架成功");
          this.search(1);
      });
    },
    createExam(name) {
      this.$router.push({
        name: "QuestionExamAdd",
        query: { name }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  .modal-item {
    border: 1px solid #eee;
    width: 180px;
    padding: 20px;
    cursor: pointer;
    .modal-item-title {
      text-align: center;
      margin-bottom: 10px;
    }
  }
}
</style>
